import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReportService } from '../../../reports/reports-service/report.service';
import { Router } from '@angular/router';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { downloadFileAsTextBlob } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';

@Component({
  selector: "app-edi-reports",
  templateUrl: "./edi-reports.component.html",
  styleUrls: ["./edi-reports.component.css"],
})
export class EdiReportsComponent implements OnInit, OnDestroy {
  reportDetails:any = [];
  reportDetailObj
  constructor(private reportService: ReportService, private router: Router) {}

  ngOnInit() {
    this.getEdiReports();
  }

  getEdiReports(){
    this.reportService.getEdiReport()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data =>{
      this.reportDetails = data;
    })
  }

  importFile(){
    this.router.navigateByUrl("billing/edireports/add")
  }

  downloadCSV(file){
      this.reportService
        .getEdiReportCSV(file._id)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = file.filePath;
            let url = urls.REPORT_SERVER_URL + name;
            downloadFileAsTextBlob(url, name);
          }
        });
}
  openReportModal(report){
    this.reportDetailObj = report
  }
  ngOnDestroy(): void { }


}
